import React from "react";
import { calculatePrefixForExercise } from "../../../../utils/prefix-calculator";
import _round from "lodash/round";
import submit from "submit-form";
import { formattedTarget, getSetCounts } from "../../../../utils/actuals";
import convertToRiR from "../../../../utils/converters/convert-intensity";
import { getExerciseName } from "../../../../parts/modals/learn-more/blockHelpers";
import { CopyExerciseComponent } from "../../../../parts/CopyExerciseComponent";

function MonthExercise({
  exercise,
  supersets,
  units,
  round,
  withWeight,
  fromMetric,
  expanded,
  date = null,
  intensityMeasure,
  isRiR,
  mobile = false,
  showCopyButton = true,
  athlete
}) {
  function hasNumber(myString) {
    return /\d/.test(myString);
  }

  const prefix = calculatePrefixForExercise(exercise._id, supersets).replace(
    ")",
    ""
  );

  // assumption is set.load is always stored as KG; so convert to user's unit
  const precision = units === "metric" ? 2 : 1;

  return (
    <div
      className={`exercise-element ${hasNumber(prefix) ? "is-superset" : ""}`}
      onClick={() => {
        if (date) {
          submit("/actions/refresh", {
            method: "GET",
            body: {
              view: "day",
              date,
            },
          });
        }
      }}
    >
      <div className="exercise-element-title justify-between">
        <div className="flex items-center gap-2">
          <span className="calendar-prefix">{prefix}</span>
          <p>{getExerciseName(exercise)}</p>
        </div>
        {showCopyButton && (
          <CopyExerciseComponent exercises={exercise} athlete={athlete} />
        )}
      </div>
      {exercise.sets.map((elem, idx) => {
        const { total, completed, missed } = getSetCounts(exercise, elem);
        const load = elem.load
          ? _round(fromMetric(elem.load, units), precision)
          : 0;
        const targetLoad = !!load && withWeight(load, units);
        return (
          <div
            className="exercise-element-set-wrapper"
            key={`${exercise._id}${idx}`}
          >
            <div
              className={`exercise-element-set${expanded ? " expanded" : ""}`}
            >
              <span
                className={
                  completed + missed === total
                    ? "dot bg-[--success]"
                    : missed === 0 && completed === 0
                    ? "dot bg-[--white-20]"
                    : "dot bg-[--information]"
                }
              ></span>
              {formattedTarget(
                elem,
                exercise.type === "primary" || exercise.type === "secondary",
                elem.load ? `${_round(elem.percentRepMax, 1)}` : "",
                "metric",
                targetLoad,
                intensityMeasure,
                isRiR
              )}
            </div>
            {mobile && elem.outcomes && (
              <div className="exercise-details-wrapper">
                <div className="exercise-headers-wrapper">
                  <span className="exercise-stat header">Actual Results:</span>
                  <span className="exercise-stat header">#</span>
                  <span className="exercise-stat header">Reps</span>
                  <span className="exercise-stat header">
                    {isRiR ? "RiR" : "RPE"}
                  </span>
                  <span className="exercise-stat header">Load</span>
                </div>
                {elem.outcomes &&
                  Object.keys(elem.outcomes).length > 0 &&
                  Object.keys(elem.outcomes).map((key, idy) => {
                    return (
                      <div
                        className="exercise-stats-wrapper"
                        key={`${idx}${idy}`}
                      >
                        <span className="exercise-stat">
                          {elem.outcomes[key].status === "completed" ? (
                            <img
                              src="/img/svg/check.svg"
                              style={{
                                filter: "var(--green-filter)",
                                width: "12px",
                              }}
                            />
                          ) : elem.outcomes[key].status === "missed" ? (
                            <img
                              src="/img/svg/priority_high_black.svg"
                              style={{
                                filter: "var(--red-filter)",
                                width: "13px",
                              }}
                            />
                          ) : null}
                        </span>

                        <span className="exercise-stat">{Number(key) + 1}</span>
                        <span className="exercise-stat">
                          {elem.outcomes[key].outcome.reps}
                        </span>
                        <span className="exercise-stat">
                          {elem.outcomes[key].outcome.rpe &&
                          elem.outcomes[key].outcome.rpe !== "AMRAP"
                            ? ` ${convertToRiR(
                                elem.outcomes[key].outcome.rpe,
                                !isRiR
                              )}`
                            : ""}
                        </span>
                        <span className="exercise-stat">
                          {elem.outcomes[key].outcome.load}
                        </span>
                      </div>
                    );
                  })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default MonthExercise;
